import { useState } from "react"

export const SwitchingStates = () => {
    // SRF = SWITCHING REQUEST FROM
    const [stat, setStat] = useState({linked: false, allowed: null})
    const [step, setStep] = useState(null)
    const [va, setVa] = useState('')
    const [srf, setSrf] = useState(null)
    const [inputs, setInputs] = useState({account:{value: '', stat: false, msg: ''}, password:{value: '', stat: false, msg: '', toggle: false}, aid:{value: '', stat: false, msg: '', toggle: false}})
    const [tpinputs, setTpinputs] = useState({google: {stat: false, msg: ""}, facebook: {stat: false, msg: ""}})
    const [otp, setOtp] = useState({inputted: '', code: '', stat: false, msg: 'Enter verification code'})
    const [finalize, setFinalize] = useState({
        submitted: false,
        exist: null,
        step: 1,
        sainfo: null,
        inputs: {password:{value: '', stat: false, msg: '', toggle: false, strength: 5}},
        btn: 'Submit',
        validated: {lc: false, uc: false, number: false, length: false, sc: false}
    })

    return {
        srf: {data: srf, set: setSrf},
        stat: {data: stat, set: setStat},
        step: {data: step, set: setStep},
        va: {data: va, set: setVa},
        inputs: {data: inputs, set: setInputs},
        tpinputs: {data: tpinputs, set: setTpinputs},
        otp: {data: otp, set: setOtp},
        finalize: {data: finalize, set: setFinalize}
    }
}